module.exports = __webpack_public_path__ + "wxMicroService/img/BD_carbanner.d676c26e.png";